import { GroupMemberDto } from './groupMemberDto';
import { GroupDetailsDto } from './groupDetailsDto';

export class GroupCreateDto {
  constructor(
    public readonly businessId: string,
    public readonly groupDetails: GroupDetailsDto,
    public readonly assignedGroupMembers: GroupMemberDto[]) {}
}
